import { supabase } from "@/lib/supabaseClient";

const API = process.env.REACT_APP_BACKEND_URL;

// Verify initials + PIN via backend, then redeem the magic-link token to
// establish a real Supabase session (RLS applies).
export async function pinLogin(restaurantId, initials, pin) {
  const resp = await fetch(`${API}/api/staff-pin-login`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ restaurant_id: restaurantId, initials, pin }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.detail || "Inloggning misslyckades");
  const { token_hash, type } = data;
  // supabase-js: for token_hash verification, provide ONLY token_hash + type (no email)
  const { error } = await supabase.auth.verifyOtp({ token_hash, type });
  if (error) throw new Error(error.message || "Kunde inte skapa session");
  return true;
}

export async function fetchRestaurantsPublic() {
  const resp = await fetch(`${API}/api/restaurants-public`);
  const data = await resp.json().catch(() => ({ restaurants: [] }));
  return data.restaurants || [];
}

async function authHeader() {
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function setStaffPin({ restaurantId, initials, email, pin }) {
  const resp = await fetch(`${API}/api/staff-pin/set`, {
    method: "POST",
    headers: { "Content-Type": "application/json", ...(await authHeader()) },
    body: JSON.stringify({ restaurant_id: restaurantId, email, initials, pin }),
  });
  const data = await resp.json().catch(() => ({}));
  if (!resp.ok) throw new Error(data.detail || "Kunde inte spara PIN");
  return true;
}

export async function listStaffPins(restaurantId) {
  const resp = await fetch(`${API}/api/staff-pin/list?restaurant_id=${encodeURIComponent(restaurantId)}`, {
    headers: { ...(await authHeader()) },
  });
  const data = await resp.json().catch(() => ({ pins: [] }));
  if (!resp.ok) return [];
  return data.pins || [];
}
